import React, { Component } from "react";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import SeasonsTable from "./seasonsTable";
import { getSeasons, deleteSeason } from "./../../services/seasonService";
import "react-confirm-alert/src/react-confirm-alert.css";
import _ from "lodash";

class Seasons extends Component {
  state = { seasons: [], sortColumn: { key: "name", order: "asc" } };

  async componentDidMount() {
    const seasons = await getSeasons();
    this.setState({ seasons });
  }

  handleDelete = async season => {
    confirmAlert({
      title: "Delete Season",
      message: "Are you sure you want to delete '" + season.name + "'?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const seasons = this.state.seasons.filter(s => s.id !== season.id);
            this.setState({ seasons });

            await deleteSeason(season.id);
          }
        },
        {
          label: "No",
          onClick: () => {}
        }
      ]
    });
  };

  handleSort = sortColumn => {
    this.setState({ sortColumn });
  };

  getSortedData = () => {
    const { seasons, sortColumn } = this.state;
    const sorted = _.orderBy(seasons, [sortColumn.key], [sortColumn.order]);
    return { seasons: sorted };
  };

  render() {
    const { sortColumn } = this.state;
    const { seasons } = this.getSortedData();

    return (
      <div>
        <h2>Seasons</h2>
        <Link
          to="/seasons/new"
          className="btn btn-primary"
          style={{ marginBottom: 20 }}
        >
          <i className="fa fa-file" />
        </Link>
        <SeasonsTable
          seasons={seasons}
          sortColumn={sortColumn}
          onEdit={this.handleEdit}
          onDelete={this.handleDelete}
          onSort={this.handleSort}
        />
      </div>
    );
  }
}

export default Seasons;



// WEBPACK FOOTER //
// ./src/components/seasons/seasons.jsx